import { render, staticRenderFns } from "./JciSupportTicketList.vue?vue&type=template&id=0c15a95f"
import script from "./JciSupportTicketList.vue?vue&type=script&lang=js"
export * from "./JciSupportTicketList.vue?vue&type=script&lang=js"
import style0 from "./JciSupportTicketList.vue?vue&type=style&index=0&id=0c15a95f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports